import React from "react";
import Select, { components } from "react-select";
import { MdOutlineUnfoldMore } from "react-icons/md";
import { PropTypes } from "prop-types";

const SelectBox = ({
  options,
  value,
  isMulti,
  placeholder,
  onChange,
  disabled,
  customStyles,
  closeMenuOnSelect,
  className,
  isClearable,
  hideSelectedValues,
  ...rest
}) => {
  const styles = {
    clearIndicator: (base) => ({
      ...base,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      maxHeight: `height` in rest ? rest.height : null,
    }),
    container: (base) => ({
      ...base,
      height: `height` in rest ? rest.height : null,
      width: `width` in rest ? rest.width : null,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 99,
    }),
    ...customStyles,
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <MdOutlineUnfoldMore className="fs-4" />
      </components.DropdownIndicator>
    );
  };

  const CustomOption = (props) => (
    <components.Option {...props}>
      <div className="d-flex align-items-center justify-content-between">
        <span>{props.data.label}</span>
        <span>{props?.data?.secLabel}</span>
      </div>
    </components.Option>
  );

  const CustomMultiValue = hideSelectedValues ? () => null : undefined;

  return (
    <>
      {`customTitle` in rest ? (
        <p className="custom-select-title position-absolute ms-2 mb-0 px-1 fw-bold text-secondary">
          {rest.customTitle}
        </p>
      ) : null}
      <Select
        options={options}
        value={value}
        components={{ DropdownIndicator, Option: CustomOption, ...(hideSelectedValues && isMulti && { MultiValue: CustomMultiValue }) }}
        styles={styles}
        placeholder={placeholder}
        isMulti={isMulti}
        onChange={(newValue, actionMeta) => {
          if (actionMeta.action === "clear" && isClearable)
            onChange(isMulti ? [] : "", actionMeta);
          else onChange(newValue, actionMeta);
        }}
        isDisabled={disabled}
        closeMenuOnSelect={closeMenuOnSelect}
        className={className}
        isClearable={isClearable}
        classNamePrefix="select"
        {...rest}
      />
    </>
  );
};

SelectBox.defaultProps = {
  value: [],
  isMulti: false,
  disabled: false,
  placeholder: "",
  customStyles: null,
  closeMenuOnSelect: true,
  className: "",
  hideSelectedValues: false,
};

SelectBox.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]),
      label: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.bool,
        ]),
        label: PropTypes.string,
      })
    ),
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]),
      label: PropTypes.string,
    }),
    PropTypes.string,
  ]),
  isMulti: PropTypes.bool,
  closeOnMenuSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  customStyles: PropTypes.object,
  customTitle: PropTypes.string,
  className: PropTypes.string,
  isClearable: PropTypes.bool,
  hideSelectedValues: PropTypes.bool,
};

export default SelectBox;
